/* Quantum Toad — scroll reveal for cocktail cards (fade + rise, staggered). */
(function () {
  function init() {
    var items = document.querySelectorAll('body.cocktails ul.grid > li');
    if (!items.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('qt-in'); });
      return;
    }
    items.forEach(function (el, i) {
      el.classList.add('qt-reveal');
      el.style.transitionDelay = (Math.min(i, 6) * 60) + 'ms';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('qt-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
